var React = require('react');

function IconNoticeSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M508.4 925.2c45.5 0 82.7-37.2 82.7-82.7H425.7c0 45.5 37.2 82.7 82.7 82.7zm268.8-248.1V449.6c0-127-88.1-233.2-206.8-261.4V160c0-34.2-27.7-62-62-62h-.2c-34.2 0-61.9 27.7-61.9 61.9v28.2c-118.7 28.1-206.8 134.4-206.8 261.4v227.4l-136.8 80.4c-2.4 1.4-3.9 4.1-3.9 6.9V793c0 4.4 3.6 8 8 8h813c4.4 0 8-3.6 8-8v-28.6c0-2.9-1.6-5.6-4.2-7l-146.4-80.3z"}));
}

IconNoticeSolid.displayName = "IconNoticeSolid";

IconNoticeSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconNoticeSolid;

IconNoticeSolid.default = IconNoticeSolid;
